<template>
  <!-- 菜单权限管理 -->
  <div class="page-wrap">
    <div class="page-container">
      <!-- 搜索筛选卡片 毛玻璃+大圆角+弥散阴影 -->
      <div class="search-card">
        <el-form inline :model="searchForm">
          <el-form-item label="定向包名称:">
            <el-input v-model="packageName" placeholder="可模糊查询" clearable size="mini"></el-input>
          </el-form-item>
          <el-form-item label="备注:">
            <el-input v-model="remark" placeholder="可模糊查询" clearable size="mini"></el-input>
          </el-form-item>
          <!-- 其他筛选项 -->
          <el-form-item>
            <el-button type="success" size="mini" @click="packagelistFun()">搜索</el-button>
            <!-- <el-button size="mini">重置</el-button> -->
          </el-form-item>
        </el-form>
      </div>

      <div class="btn-toolbar">
        <!-- 左侧按钮组 -->
        <div class="left-buttons">
          <el-button-group class="my-btn-group">
            <el-button plain size="mini" icon="el-icon-coin" class="btn-green"
              @click="openAddPackage()">添加投放定向包</el-button>
          </el-button-group>
        </div>
      </div>

      <!-- 下方表格卡片 -->
      <div class="table-card">
        <el-table :data="tableData" border style="width: 100%">
          <el-table-column prop="userName" label="创建人" width="100"> </el-table-column>
          <el-table-column prop="packageName" label="定向包名称" width="180"> </el-table-column>
          <el-table-column prop="regionRemark" label="地域" width="180"> </el-table-column>
          <el-table-column prop="remark" label="备注"> </el-table-column>
          <el-table-column prop="updateTime" label="修改时间" width="180"> </el-table-column>
          <el-table-column prop="regionRemark" label="操作" width="100">

            <template #default="scope">
              <el-button type="primary" @click="packageEdit(scope)" icon="el-icon-edit" circle size="mini"></el-button>
              <el-button type="danger" @click="packagedeleteFun2(scope)" icon="el-icon-delete" circle
                size="mini"></el-button>
            </template>

          </el-table-column>
        </el-table>
      </div>

      <!-- 分页 -->
      <div class="pagination-wrap">
        <pagination @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange" :total="total"
          :pagesize="pagesize" :currentPage="currentPage"></pagination>
      </div>
    </div>

    <!-- 添加和修改 共用 定向包管理弹窗控制 -->
    <el-dialog :title="sId == '' ? '添加定向包' : '修改定向包'" v-model="DXBview" width="60%" class="dialog‑green"
      @closed="handlePackageDialogClosed">
      <el-form ref="formRef" :model="form" label-width="120px">
        <el-form-item label="定向包名称">
          <el-input v-model="form.packageName" placeholder="例如: 端/漫/男频/女频/通用包" clearable style="width:520px"></el-input>
        </el-form-item>

        <el-form-item label="地域">
          <el-select v-model="form.regionItem" clearable @click="regionListFun()" placeholder="请选择地域"
            style="width:520px">
            <el-option v-for="item in regionData" :key="item.id" :label="item.remark" :value="item.id"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="性别">
          <el-radio-group v-model="form.gender">
            <el-radio :label="'NONE'">不限</el-radio>
            <el-radio :label="'GENDER_FEMALE'">女</el-radio>
            <el-radio :label="'GENDER_MALE'">男</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="年龄">
          <el-checkbox-group v-model="form.age">
            <el-checkbox :label="'NONE'">不限</el-checkbox>
            <el-checkbox :label="'AGE_BETWEEN_18_23'">18‑23</el-checkbox>
            <el-checkbox :label="'AGE_BETWEEN_24_30'">24‑30</el-checkbox>
            <el-checkbox :label="'AGE_BETWEEN_31_40'">31‑40</el-checkbox>
            <el-checkbox :label="'AGE_BETWEEN_41_49'">41‑49</el-checkbox>
            <el-checkbox :label="'AGE_ABOVE_50'">50+</el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item label="网络">
          <el-checkbox-group v-model="form.network">
            <el-checkbox :label="'unknown'">不限</el-checkbox>
            <el-checkbox :label="'WIFI'">WIFI</el-checkbox>
            <el-checkbox :label="'2G'">2G</el-checkbox>
            <el-checkbox :label="'3G'">3G</el-checkbox>
            <el-checkbox :label="'4G'">4G</el-checkbox>
            <el-checkbox :label="'5G'">5G</el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item label="设备类型">
          <el-checkbox-group v-model="form.deviceType">
            <el-checkbox :label="'MOBILE'">手机</el-checkbox>
            <el-checkbox :label="'PAD'">平板</el-checkbox>
          </el-checkbox-group>
        </el-form-item>

        <el-form-item label="过滤已转化用户">
          <el-radio-group v-model="form.filterConvertedUser">
            <el-radio :label="'NO_EXCLUDE'">不限(R1)</el-radio>
            <el-radio :label="'PROMOTION'">单元(R1)</el-radio>
            <el-radio :label="'PROJECT'">项目(R1)</el-radio>
            <el-radio :label="'ADVERTISER'">广告账户(R1)</el-radio>
            <el-radio :label="'APP'">应用【当天】(R1)</el-radio>
            <el-radio :label="'CUSTOMER'">客户【当天】(R1)</el-radio>
            <el-radio :label="'ORGANIZATION'">组织【当天】(R1)</el-radio>
            <el-radio :label="'NO_EXCLUDE'">不限制(R3)</el-radio>
            <el-radio :label="'PROJECT'">项目(R3)</el-radio>
            <el-radio :label="'ADVERTISER'">投放账户(R3)</el-radio>
            <el-radio :label="'CUSTOMER'">客户(R3)</el-radio>
            <el-radio :label="'ORGANIZATION'">组织(R3)</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item label="备注">
          <el-input v-model="form.remark" type="textarea" :rows="4" maxlength="50" placeholder="定向包备注信息，最大长度不超过50个字"
            style="width:520px"></el-input>
        </el-form-item>

        <el-form-item>
          <el-button v-if="sId == ''" type="primary" size="mini" @click="packageaddFun()">添加定向包</el-button>
          <el-button v-if="sId != ''" type="primary" size="mini" @click="packageupdateFun()">修改定向包</el-button>
          <el-button size="mini" @click="handleResetPackage()">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 删除定向包管理弹窗控制 -->
    <el-dialog v-model="deDXBview" title="删除定向包" width="30%">
      <el-form label-width="120px">
        <el-form-item>
          <font style="color:red">确定删除定向包？</font>
        </el-form-item>
      </el-form>
      <el-form-item>
        <el-button type="primary" size="mini" @click="packagedeleteFun()">确定删除</el-button>
        <el-button size="mini" @click="changedeDXBviewFun()">取消</el-button>
      </el-form-item>
    </el-dialog>
  </div>
</template>

<script>
import { packagelist, packagedelete, packageupdate, packageadd, regionList } from '@/request/new/ylyBatch'
import { ElMessage } from 'element-plus'
import { inject, reactive, toRefs, watch } from 'vue'
import pagination from '@/components/pagination.vue' // 导入分页组件

export default {
  name: 'ylyPackage',
  components: { pagination },
  setup() {
    const state = reactive({
      //定向包名称
      packageName: '',
      //备注
      remark: '',
      //选中的id
      sId: '',
      //表格数据
      tableData: [],
      //地域数据
      regionData: [],
      //定向包重置数据
      restform: {
        packageName: '',
        regionItem: '',
        region: '',
        regionRemark: '',
        gender: 'NONE',
        age: ['NONE'],
        network: ['unknown'],
        deviceType: ['MOBILE', 'PAD'],
        filterConvertedUser: 'NO_EXCLUDE',
        remark: ''
      },
      //添加定向包的数据
      form: {
        packageName: '',
        regionItem: '',
        region: '',
        regionRemark: '',
        gender: 'NONE',
        age: ['NONE'],
        network: ['unknown'],
        deviceType: ['MOBILE', 'PAD'],
        filterConvertedUser: 'NO_EXCLUDE',
        remark: ''
      },
      //添加定向包开关
      DXBview: false,
      //添加定向包开关控制
      changeDXBviewFun: () => {
        state.DXBview = !state.DXBview
      },
      //打开添加定向包弹窗（重置编辑态，避免残留修改数据）
      openAddPackage: () => {
        state.sId = ''
        state.form = JSON.parse(JSON.stringify(state.restform))
        state.DXBview = true
      },
      //弹窗关闭后统一重置，保证下次打开是干净状态
      handlePackageDialogClosed: () => {
        state.sId = ''
        state.form = JSON.parse(JSON.stringify(state.restform))
      },
      //删除定向包
      deDXBview: false,
      //删除定向包开关控制
      changedeDXBviewFun: () => {
        state.deDXBview = !state.deDXBview
      },
      //删除按钮
      packagedeleteFun2: (scope) => {
        state.sId = scope.row.id
        state.changedeDXBviewFun()
      },
      //编辑按钮
      packageEdit: (scope) => {
        state.regionListFun()
        state.sId = scope.row.id
        state.form.packageName = scope.row.packageName
        state.form.regionItem = scope.row.region
        state.form.region = scope.row.region
        state.form.regionRemark = scope.row.regionRemark
        state.form.gender = scope.row.gender
        state.form.age = JSON.parse(scope.row.age)
        state.form.network = JSON.parse(scope.row.network)
        state.form.deviceType = JSON.parse(scope.row.deviceType)
        state.form.filterConvertedUser = scope.row.filterConvertedUser
        state.form.remark = scope.row.remark
        state.DXBview = true
      },
      //修改定向包
      packageupdateFun: () => {
        if (state.form.packageName.length > 0 && state.form.regionItem != '') {
          const regionItem = state.regionData.find((item) => item.id == state.form.regionItem)
          state.form.region = state.form.regionItem
          state.form.regionRemark = regionItem ? regionItem.remark : ''

          const datas = {
            id: state.sId,
            packageName: state.form.packageName,
            region: state.form.region,
            regionRemark: state.form.regionRemark,
            gender: state.form.gender,
            age: JSON.stringify(state.form.age),
            network: JSON.stringify(state.form.network),
            deviceType: JSON.stringify(state.form.deviceType),
            filterConvertedUser: state.form.filterConvertedUser,
            remark: state.form.remark,
          }
          packageupdate(datas).then((res) => {
            console.log('修改定向包', res)
            if (res.code == 200) {
              ElMessage.success('修改成功')
              state.form = JSON.parse(JSON.stringify(state.restform))
              state.sId = ''
              state.changeDXBviewFun()
              packagelistFun()
            }
          })
        } else {
          ElMessage.error('数据不能为空')
        }

      },
      // 条数
      pagesize: 50,
      // 当前页数
      currentPage: 1,
      // 总数
      total: 100,
      // 页数 发生改变
      handleCurrentChange: (e) => {
        state.currentPage = e
        packagelistFun()
      },
      // 个数 发生改变
      handleSizeChange: (e) => {
        state.pagesize = e
        packagelistFun()
      },
      //查询地域数据
      regionListFun: () => {
        regionList().then((res) => {
          state.regionData = res.data
        })
      },
      //重置定向包
      handleResetPackage: () => {
        // 深拷贝 restform，切断引用
        state.form = JSON.parse(JSON.stringify(state.restform))
      },
      //添加定向包
      packageaddFun: () => {
        if (state.form.packageName.length > 0 && state.form.regionItem != '') {
          state.form.region = state.form.regionItem.id
          state.form.regionRemark = state.form.regionItem.remark

          const datas = {
            packageName: state.form.packageName,
            region: state.form.region,
            regionRemark: state.form.regionRemark,
            gender: state.form.gender,
            age: JSON.stringify(state.form.age),
            network: JSON.stringify(state.form.network),
            deviceType: JSON.stringify(state.form.deviceType),
            filterConvertedUser: state.form.filterConvertedUser,
            remark: state.form.remark,
          }
          packageadd(datas).then((res) => {
            console.log('添加定向包', res)
            if (res.code == 200) {
              ElMessage.success('添加成功')
              state.form = JSON.parse(JSON.stringify(state.restform))
              state.changeDXBviewFun()
              packagelistFun()
            }
          })
        } else {
          ElMessage.error('数据不能为空')
        }
      },
      //删除定向包
      packagedeleteFun: () => {
        const datas = {
          id: state.sId
        }
        packagedelete(datas).then((res) => {
          ElMessage.success('删除成功')
          state.changedeDXBviewFun()
          packagelistFun()
          state.sId = ''
        })
      },

    })

    const packagelistFun = () => {
      const datas = {
        packageName: state.packageName,
        remark: state.remark,
        currenPage: state.currentPage,
        size: state.pagesize,

      }
      packagelist(datas).then((res) => {
        state.currentPage = res.data.currenPage
        state.total = res.data.totalSize
        state.tableData = res.data.data
      })
    }

    packagelistFun()

    return {
      // 结构赋值，暴露出去就不用 state.xx
      ...toRefs(state),
      packagelistFun
    }
  },
}
</script>

<style lang="scss" scoped>
// 全局页面浅色渐变背景
.page-wrap {
  min-height: 100vh;
  padding: 20px;
  background: linear-gradient(135deg, #f7f9fc 0%, #edf2fa 100%);
}

.page-container {
  display: flex;
  flex-direction: column;
  gap: 18px;
}

// 搜索卡片：毛玻璃、大圆角、弥散柔和阴影
.search-card {
  border-radius: 18px;
  padding: 20px 24px;
  background: rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.06), 0 2px 8px rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.85);
  transition: all 0.32s ease;
}

// 表格卡片
.table-card {
  border-radius: 18px;
  padding: 16px;
  background: rgba(255, 255, 255, 0.72);
  backdrop-filter: blur(12px);
  -webkit-backdrop-filter: blur(12px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.06), 0 2px 8px rgba(0, 0, 0, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.85);
  overflow: hidden;
}

.pagination-wrap {
  padding: 8px 4px;
}

.btn-toolbar {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.left-buttons {
  display: flex;
  gap: 2px;
  flex-shrink: 1;
  overflow-x: auto;
  padding-bottom: 4px;
}

// ========= ElementPlus 组件深度修改 现代UI 大圆角+hover平滑动画 =========
:deep() {

  // 输入框、选择器大圆角
  .el-input__inner,
  .el-select .el-input__inner {
    border-radius: 12px !important;
    border-color: #e2e8f0;
    transition: all 0.28s cubic‑bezier(0.4, 0, 0.2, 1);

    &:hover {
      border‑color: #b8c8e3;
      box‑shadow: 0 0 0 3px rgba(64, 158, 255, 0.08);
    }

    &:focus {
      box‑shadow: 0 0 0 3px rgba(64, 158, 255, 0.12);
    }
  }

  // 按钮统一大圆角+平滑hover微交互
  .el-button {
    border‑radius: 12px !important;
    transition: all 0.28s cubic‑bezier(0.4, 0, 0.2, 1);
    box‑shadow: 0 2px 6px rgba(0, 0, 0, 0.04);

    &:hover {
      transform: translateY(-1px);
      box‑shadow: 0 6px 14px rgba(0, 0, 0, 0.08);
    }

    &:active {
      transform: translateY(0px);
    }
  }

  // 表格样式美化，去掉生硬边框，圆角
  .el-table {
    border‑radius: 14px;
    overflow: hidden;
  }

  .el-table th.el-table__cell {
    background‑color: #f4f7fc !important;
  }

  .el-table__row:hover>td {
    background‑color: rgba(64, 158, 255, 0.04) !important;
  }

  // 弹窗 毛玻璃大圆角弥散阴影
  .modern-dialog.el-dialog {
    border‑radius: 20px;
    overflow: hidden;
    background: rgba(255, 255, 255, 0.78);
    backdrop‑filter: blur(16px);
    -webkit‑backdrop‑filter: blur(16px);
    box‑shadow: 0 12px 45px rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.9);
  }

  .el-dialog__header {
    padding: 22px 26px 12px;
  }

  .el-dialog__body {
    padding: 10px 26px 22px;
  }

  // 分页组件圆角
  .el-pagination {

    .el-pager li,
    .el-pagination__btn {
      border‑radius: 10px;
    }
  }
}

/* 你的按钮颜色样式保留 */
.btn-orange {
  background-color: #ff9500;
  color: white;
  border: none;
}

.btn-green {
  background-color: #00b42a;
  color: white;
  border: none;
}

.btn-blue {
  background-color: #409eff;
  color: white;
  border: none;
}

.btn-dark-blue {
  background-color: #2b5cb8;
  color: white;
  border: none;
}

.btn-purple {
  background-color: #722ed1;
  color: white;
  border: none;
}

.btn-red {
  background-color: #f53f3f;
  color: white;
  border: none;
}

.btn-dark {
  background-color: #1d2129;
  color: white;
  border: none;
}

.btn-light-blue {
  background-color: #69b1ff;
  color: white;
  border: none;
}

.btn-sky {
  background-color: #40c9ff;
  color: white;
  border: none;
}
</style>